export enum ArweaveTransactionStatus {
    New = 'New',
    Complete = 'Complete'
}